

























import { Component, Vue } from 'vue-property-decorator';

@Component
export default class TabBoxComponent extends Vue {
  private valueTab = '';

  private created() {
    this.$bus.$on('cleanValueTab', () => (this.valueTab = ''));
  }

  private addTextLocalStorage() {
    localStorage.setItem('tabulacao', this.valueTab);
  }
}
